const PageTransition = ({ children }: { children: React.ReactNode }) => (
  <div className="animate-page-fade-in">
    {children}
  </div>
);

export default PageTransition;
